'use client';

import React,{ useState  } from 'react';
import { v4 as uuid } from 'uuid';
import {
  CatCarouselItem,
  CatIconArrowBack,
  CatIconArrowForward,
  CatButton
} from 'components/blocks-components';
import { useBreakpoint } from 'components/pcc-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import { ProductCardCarousel } from '../../../product-card/product-card-carousel';
import ProductComparisonGrid from 'components/product-comparison-grid';
import styles from './../recently-viewed.module.scss';

export const RecentViewCarousel = ({ children }) => {
  const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
  const isXL = useBreakpoint(PAGE_BREAKPOINTS.XL);

  const [currentSlide, setCurrentSlide] = useState(0);

  const childrenArray = React.Children.toArray(children);
  const itemsPerSlide = isXL ? 4 : 3;
  const isSingleSlide = childrenArray.length <= itemsPerSlide;

  if ((!isLG && isLG !== undefined) || isSingleSlide) {
    return (
      <ProductComparisonGrid classname={styles['recently-viewed-grid-wrapper']}>
        {children}
      </ProductComparisonGrid>
    );
  }

  const slides = Array.from({
    length: Math.ceil(childrenArray.length / itemsPerSlide)
  });
  const totalSlides = slides.length;

  const handleSlideChange = (direction: 'previous' | 'next') => {
    setCurrentSlide((currentSlide) =>
      direction === 'previous'
        ? Math.max(0, currentSlide - 1)
        : Math.min(totalSlides - 1, currentSlide + 1)
    );
  };


  return (
    <ProductCardCarousel>
      <CatButton
        slot="previous-icon"
        disabled={currentSlide === 0}
        onClick={() => handleSlideChange('previous')}
        className={styles['carousel-button']}
      >
        <CatIconArrowBack />
      </CatButton>
      <CatButton
        slot="next-icon"
        disabled={currentSlide === totalSlides - 1}
        onClick={() => handleSlideChange('next')}
        className={styles['carousel-button']}
      >
        <CatIconArrowForward />
      </CatButton>
      {slides.map((_, index) => (
        <CatCarouselItem key={uuid()}>
          <ProductComparisonGrid
            classname={styles['recently-viewed-grid-wrapper']}
          >
            {childrenArray.slice(
              index * itemsPerSlide,
              (index + 1) * itemsPerSlide
            )}
          </ProductComparisonGrid>
        </CatCarouselItem>
      ))}
    </ProductCardCarousel>
  );
};